<template>
	<!-- 优惠券管理 -->
	<div class="public_Spacing carManagement">
		<div class="pulbic_oparetionBlock">
			<!-- <div class="public_criteriaRange">
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">车牌号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input maxlength="7" class="el-input__inner pulic_carNumber" type="text" placeholder="请输入"
								v-model="carNum" />
						</div>
					</div>
				</div>
			</div> -->
			<div class="public_operatArea">
				<div class="public_operatBtn" style="margin-left: 0;">
					<!-- <button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist"
						id="查询"><i class="iconfont icon-chaxun"></i>查询</button> -->
					<button @click="newlyAdd" class="public_saleWater_xinzeng pulic_cursor" v-shiroHiden="solelist"
						id="新增"><i class="iconfont icon-tianjia1"></i>新增</button>
					<!-- <button @click="exports" class="public_saleWater_daochu pulic_cursor"     id="导出"><i class="iconfont icon-daochu"></i>导出</button> -->
				</div>
			</div>
		</div>
		<div class="bcarManagement-table pulbic_table_container">
			<el-table :data="tableData" style="width: 100%;" max-height="90%" stripe
				:default-sort="{prop: 'waterNum', order: 'descending'}"
				:header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}" class="public_tableColumn">
				<el-table-column :show-overflow-tooltip="true" v-for='(item,index) in tableHeadList' :prop="item.prop"
					:label="item.label" :key="index">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button @click="modify(scope.row)"
							class="public_icon_xiugai public_icon_width  public_icon_margin" v-shiroHiden="solelist"
							id="修改" type="primary" size="small">修改</el-button>
						<el-button v-shiroHiden="solelist" id="删除" @click="deleteClick(scope.row)"
							class="public_icon_jinyong public_icon_width" type="primary" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next, jumper" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>

		<!-- 新增 -->
		<div class="public-dialog">
			<el-dialog title="添加优惠券" @close="XAdd" :visible.sync="billOperationAdd" width="60%"
				:closeOnClickModal='false' append-to-body custom-class="sales-coupon-dialog">
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
					<el-row :gutter="24">
						<el-col :span="6">
							<el-form-item label="优惠券名称" prop="name">
								<el-input v-model="ruleForm.name"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="优惠券金额" prop="yhje">
								<el-input type="number" v-model="ruleForm.yhje"></el-input>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="6">
							<el-form-item label="描述" prop="ms">
								<el-input v-model="ruleForm.ms"></el-input>
							</el-form-item>
						</el-col> -->
						<el-col :span="6">
							<el-form-item label="获得券门槛金额" prop="hdmkje">
								<el-input type="number" v-model="ruleForm.hdmkje"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="使用券门槛金额" prop="symkje">
								<el-input type="number" v-model="ruleForm.symkje"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="24">

						<el-col :span="12">
							<el-form-item label="使用类型" prop="sylx" style="margin-top:16px">
								<el-radio-group v-model="ruleForm.sylx" size="small">
									<el-radio-button label="通用券">通用券</el-radio-button>
									<el-radio-button label="指定厂家券">指定厂家券</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="客户等级" prop="grade">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAllGrade"
							@change="handleCheckAllChange">全选</el-checkbox>

						<el-checkbox-group v-model="checkedCitiesGrade" @change="handleCheckedCitiesChange">
							<el-checkbox v-for="(city,i) in ruleForm.grade" :label="city" :key="i">
								{{city.SETTB206CA01}}
							</el-checkbox>

						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="可获得券厂家" prop="hdcj">
						<el-checkbox :indeterminate="isIndeterminateHdcj" v-model="checkAllHdcj"
							@change="handleCheckAllHdcjChange">全选</el-checkbox>
						<el-checkbox-group v-model="checkedCitiesHdcj" @change="handleCheckedCitiesHdcjChange">
							<el-checkbox v-for="(city,i) in ruleForm.hdcj" :label="city" :key="i">
								{{city.SETTB99CA00}}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="可使用券厂家" prop="sycj">
						<el-checkbox :indeterminate="isIndeterminateSycj" v-model="checkAllSycj"
							@change="handleCheckAllSycjChange">全选</el-checkbox>
						<el-checkbox-group v-model="checkedCitiesSycj" @change="handleCheckedCitiesSycjChange">
							<el-checkbox v-for="(city,i) in ruleForm.sycj" :label="city" :key="i">
								{{city.SETTB99CA00}}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<el-form-item label="有效期" prop="jzsj">
						<el-input type="number" placeholder="请输入内容" v-model="ruleForm.jzsj" @mousewheel.native.prevent
							@keyup.native="prevent($event)">
							<template slot="append">天</template>
						</el-input>
						<!-- <el-date-picker v-model="ruleForm.jzsj" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期时间">
						</el-date-picker> -->
					</el-form-item>
					<el-form-item>
						<!-- submitForm -->
						<!-- preservationAdd -->
						<el-button type="primary" @click="preservationAdd('ruleForm')">提交</el-button>
						<el-button @click="resetForm('ruleForm')">取消</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
		<!-- 修改 -->
		<div class="public-dialog">
			<el-dialog title="修改优惠券信息" @close="XAdd" :visible.sync="billOperationDetails" width="60%"
				:closeOnClickModal='false' append-to-body custom-class="sales-coupon-dialog">
				<el-form :model="editRuleForm" :rules="rules" ref="editRuleForm" label-width="auto"
					class="demo-ruleForm">
					<el-row :gutter="24">
						<el-col :span="6">
							<el-form-item label="优惠券名称" prop="name">
								<el-input v-model="editRuleForm.name"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="优惠券金额" prop="yhje">
								<el-input type="number" v-model="editRuleForm.yhje"></el-input>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="6">
							<el-form-item label="描述" prop="ms">
								<el-input v-model="ruleForm.ms"></el-input>
							</el-form-item>
						</el-col> -->
						<el-col :span="6">
							<el-form-item label="获得券门槛金额" prop="hdmkje">
								<el-input type="number" v-model="editRuleForm.hdmkje"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="使用券门槛金额" prop="symkje">
								<el-input type="number" v-model="editRuleForm.symkje"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="24">

						<el-col :span="12">
							<el-form-item label="使用类型" prop="sylx" style="margin-top:16px">
								<el-radio-group v-model="editRuleForm.sylx" size="small">
									<el-radio-button label="通用券">通用券</el-radio-button>
									<el-radio-button label="指定厂家券">指定厂家券</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item label="客户等级" prop="grade">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAllGrade"
							@change="handleCheckAllChange">全选</el-checkbox>

						<el-checkbox-group v-model="checkedCitiesGrade" @change="handleCheckedCitiesChange">
							<el-checkbox v-for="(city,i) in editRuleForm.grade" :label="city.SETTB206CA00"
								:value="city.SETTB206CA00" :key="city.SETTB206CA00">
								{{city.SETTB206CA01}}
							</el-checkbox>

						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="可获得券厂家" prop="hdcj">
						<el-checkbox :indeterminate="isIndeterminateHdcj" v-model="checkAllHdcj"
							@change="handleCheckAllHdcjChange">全选</el-checkbox>
						<el-checkbox-group v-model="checkedCitiesHdcj" @change="handleCheckedCitiesHdcjChange">
							<el-checkbox v-for="(city,i) in editRuleForm.hdcj" :label="city.SETTB99ID"
								:value="city.SETTB99ID" :key="city.SETTB99ID">
								{{city.SETTB99CA00}}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="可使用券厂家" prop="sycj">
						<el-checkbox :indeterminate="isIndeterminateSycj" v-model="checkAllSycj"
							@change="handleCheckAllSycjChange">全选</el-checkbox>
						<el-checkbox-group v-model="checkedCitiesSycj" @change="handleCheckedCitiesSycjChange">
							<el-checkbox v-for="(city,i) in editRuleForm.sycj" :label="city.SETTB99ID"
								:value="city.SETTB99ID" :key="city.SETTB99ID">
								{{city.SETTB99CA00}}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<el-form-item label="有效期" prop="jzsj">
						<el-input type="number" placeholder="请输入内容" v-model="editRuleForm.jzsj" @mousewheel.native.prevent
							@keyup.native="prevent($event)">
							<template slot="append">天</template>
						</el-input>
					<!-- 	<el-date-picker v-model="editRuleForm.jzsj" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期时间">
						</el-date-picker> -->
					</el-form-item>
					<el-form-item>
						<!-- submitForm -->
						<!-- preservationAdd -->
						<el-button type="primary" @click="preservationModify('editRuleForm')">提交</el-button>
						<el-button @click="cancelModify">取消</el-button>
					</el-form-item>
				</el-form>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
	export default {
  mixins: [enterpriseSearchMixin],
		data() {
			return {
				userobj: this.$store.state.uobj, //登陆缓存--用户信息
				carNum: "",
				billOperationAdd: false,
				billOperationDetails: false,
				tableData: [],
				addEdit: 0,
				akh: [],
				tableHeadList: [{
						prop: 'SETTB408CA00',
						label: '优惠券名称',
					},
					{
						prop: 'SETTB408CA05',
						label: '优惠券类型',
					},
					{
						prop: 'SETTB408CA01',
						label: '优惠券金额',
					},

					{
						prop: 'SETTB408CA03',
						label: '优惠券获得门槛金额',
					}, {
						prop: 'SETTB408CA04',
						label: '优惠券使用门槛金额',
					},
					{
						prop: 'SETTB408CA09',
						label: '到期时间',
					},
					{
						prop: 'SETTB408CB00',
						label: '获得优惠券厂家',
					},
					{
						prop: 'SETTB408CB01',
						label: '使用优惠券厂家',
					},
					// {
					// 	prop: 'SETTB408CA02',
					// 	label: '描述',
					// },

				],

				ruleForm: {
					name: '',
					yhje: '',
					ms: '',
					hdmkje: '',
					symkje: '',
					sylx: '指定厂家券',
					hdcj: [],
					hdcjName: [],
					sycj: [],
					sycjName: [],
					grade: [], //客户等级
					resource: '',
					jzsj: ''
				},
				editRuleForm: {
					name: '',
					yhje: '',
					ms: '',
					hdmkje: '',
					symkje: '',
					sylx: '指定厂家券',
					hdcj: [],
					hdcjName: [],
					sycj: [],
					sycjName: [],
					grade: [], //客户等级
					resource: '',
					jzsj: ''
				},
				checkedCitiesGrade: [], //绑定默认选中客户等级
				checkedCitiesHdcj: [], //绑定默认选中可获得券厂家
				checkedCitiesSycj: [], //绑定默认选中可使用券厂家

				sendVisible: false,
				isIndeterminate: false, // 客户等级全选
				isIndeterminateHdcj: false, //可获得券厂家
				isIndeterminateSycj: false, //可使用券厂家
				checkAllGrade: false, //客户等级
				checkAllHdcj: false, //获得券厂家
				checkAllSycj: false, //使用券厂家
				userArr: [],
				nameArr: [],
				rowId: '',
				rules: {
					name: [{
							required: true,
							message: '请输入名称',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 10,
							message: '长度在 3 到 10 个字符',
							trigger: 'blur'
						}
					],
					yhje: [{
						required: true,
						message: '请输入优惠券金额',
						trigger: 'blur'
					}],
					ms: [{
						required: true,
						message: '请输入描述',
						trigger: 'blur'
					}],
					hdmkje: [{
						required: true,
						message: '请输入获得优惠券门槛金额',
						trigger: 'blur'
					}],
					symkje: [{
						required: true,
						message: '请输入使用优惠券门槛金额',
						trigger: 'blur'
					}],
					sylx: [{
						required: true,
						message: '请选择使用类型',
						trigger: 'change'
					}],
					grade: [{
						required: true,
						message: '请选择客户等级',
						trigger: 'change'
					}],
					hdcj: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					sycj: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					jzsj: [{
						required: true,
						message: '请输入有效期',
						trigger: 'change'
					}]
				},
				// 新增
				carNumberAdd: '',
				carNameAdd: '',
				carPhoneAdd: '',
				tareIptAdd: '',
				judgeAdd: 0, //判断校验车辆，车辆类型是新增还是修改--新增
				maxl: '',
				// 修改
				SETTB402ID: '', //车辆id
				carNumberModify: '',
				carNameModify: '',
				carPhoneModify: '',
				tareIptModify: '',
				carID: '', //一二级客户车辆id
				judgeModify: 1, //判断校验车辆，车辆类型是新增还是修改--修改
				judgeCarNumMo: '', //判断修改时当前输入的车牌号是否和未修改之前的一样--修改
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: '',

				solelist: [],
			}
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			this.userobj = this.$store.state.uobj;
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}

		},
		watch: {
			// 车牌号--查询
			carNum: function(val) {
				this.carNum = val.toUpperCase()
			},
			// 车牌号--新增
			carNumberAdd: function(val) {
				this.carNumberAdd = val.toUpperCase()
			},
			// 车牌号--修改
			carNumberModify: function(val) {
				this.carNumberModify = val.toUpperCase()
			},
			sendVisible: {
				handler(visible) {
					if (visible) {
						this.userArr = this.memberList
						// 勾选的数组绑定的是数组中的item.name(label),这里要过滤出全为name的数组
						let tempNameArr = []
						this.memberList.forEach(item => {
							tempNameArr.push(item.name)
						})
						this.nameArr = tempNameArr
					}
				},
				immediate: true,
				deep: true
			}

		},
		mounted() {
			this.pageList();
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				carNum: this.carNum, //车牌号
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo //每页条数
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
			loadEnterpriseOptions() {
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					type: 1
				}
				var List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
				this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
					if (res.data.code == 200) {
						this.enterpriseTwoOptionList = [...List, ...res.data.data]
						this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
						// 同步厂家列表到表单字段（复选框数据源）
						this.ruleForm.hdcj = res.data.data
						this.ruleForm.sycj = res.data.data
						this.editRuleForm.hdcj = res.data.data
						this.editRuleForm.sycj = res.data.data
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},
			prevent(e){
			 var keynum = window.event ? e.keyCode : e.which;   //获取键盘码
			    if (keynum ==189|| keynum==190||keynum == 109 ||keynum == 110 ) {
			        this.$message.warning('禁止输入小数以及负数')
			        e.target.value = ''
			    }
			},
			customerManagementQuery() { //获取客户等级列表
				this.ruleForm.grade = []
				var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.ruleForm.grade = res.data.data
						this.editRuleForm.grade = res.data.data


					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},



			handleCheckAllChange(val) { //客户等级全选
				// console.log(val)
				// console.log(this.addEdit)
				if (this.addEdit == 0) {
					this.checkedCitiesGrade = val ? this.ruleForm.grade : [];
					// console.log(this.checkedCitiesGrade)
					this.isIndeterminate = false;
					return
				}
				if (this.addEdit == 1) {
					if (val == true && this.addEdit == 1) {
						for (let i = 0; i < this.editRuleForm.grade.length; i++) {
							// if (this.editRuleForm.grade[i].containPreferential == 1) {
							this.checkedCitiesGrade.push(this.editRuleForm.grade[i].SETTB206CA00);
							// console.log(this.checkedCitiesGrade)
							// }
						}
					} else {
						this.checkedCitiesGrade = []
					}
					this.isIndeterminate = false;


				}


			},
			handleCheckAllHdcjChange(val) { //可获得券厂家全选
				if (this.addEdit == 0) {
					this.checkedCitiesHdcj = val ? this.ruleForm.hdcj : [];
					this.isIndeterminateHdcj = false;
				}
				if (this.addEdit == 1) {
					if (val == true && this.addEdit == 1) {
						for (let i = 0; i < this.editRuleForm.hdcj.length; i++) {
							this.checkedCitiesHdcj.push(this.editRuleForm.hdcj[i].SETTB99ID);
							// console.log(this.checkedCitiesHdcj)

						}
					} else {
						this.checkedCitiesHdcj = []
					}
					this.isIndeterminateHdcj = false;
				}


			},
			handleCheckAllSycjChange(val) { //可使用券厂家全选
				if (this.addEdit == 0) {
					this.checkedCitiesSycj = val ? this.ruleForm.sycj : [];
					this.isIndeterminateSycj = false;
				}
				if (this.addEdit == 1) {
					if (val == true && this.addEdit == 1) {
						for (let i = 0; i < this.editRuleForm.sycj.length; i++) {
							this.checkedCitiesSycj.push(this.editRuleForm.sycj[i].SETTB99ID);
							// console.log(this.checkedCitiesSycj)

						}
					} else {
						this.checkedCitiesSycj = []
					}
					this.isIndeterminateSycj = false;
				}


			},

			handleCheckedCitiesChange(value) { //客户等级单选
				let checkedCount = value.length;
				// console.log(checkedCount)
				this.checkAllGrade = checkedCount === this.ruleForm.grade.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.ruleForm.grade.length;
				// console.log(value)
			},
			handleCheckedCitiesHdcjChange(value) { //可获得券厂家单选
				let checkedCount = value.length;
				this.checkAllHdcj = checkedCount === this.ruleForm.hdcj.length;
				this.isIndeterminateHdcj = checkedCount > 0 && checkedCount < this.ruleForm.hdcj.length;
			},
			handleCheckedCitiesSycjChange(value) { //可使用券厂家单选
				let checkedCount = value.length;
				this.checkAllSycj = checkedCount === this.ruleForm.sycj.length;
				this.isIndeterminateSycj = checkedCount > 0 && checkedCount < this.ruleForm.sycj.length;
			},
			resetForm(formName) {
				// console.log(formName)
				this.billOperationAdd = false;
				this.$refs[formName].resetFields();
				this.checkedCitiesGrade = []
				this.checkedCitiesHdcj = []
				this.checkedCitiesSycj = []
				this.isIndeterminate = false
				this.isIndeterminateHdcj = false
				this.isIndeterminateSycj = false
				this.checkAllGrade = false
				this.checkAllHdcj = false
				this.checkAllSycj = false

			},


			//初始化数据
			init() {
				this.carNum = this.historyInfo.carNum
				this.currentPage = this.historyInfo.currentPage
				this.pageMo = this.historyInfo.pageMo
				this.limitMo = this.historyInfo.limitMo
			},
			// 导出
			exports() {
				var SETTB402CA00 = this.carNum; //车牌号
				var url = this.axios.defaults.baseURL + "/set/settb402/toExcel?SETTB402CA00=" + SETTB402CA00;
				window.location.href = url;
			},
			// 删除
			deleteClick(row) {
				var postData = {
					// sign: this.userobj.pertb005.pertb005cb00,
					SETTB408ID: row['SETTB408ID'],
					// SETTB402ID: row['carNumID'],
				}
				var url = "/set/settb408/delete";
				this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios.post(url, postData).then(res => {
						// console.log(res)
						if (res.data.code == 200) {
							this.pageList()
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					})
				})
			},
			numinput() {
				this.carNumberAdd = this.checkNum(this.carNumberAdd)
			},
			checkNum(item) {
				var regNum = /^[0-9]+$/
				var regALP = /^[0-9A-Z]+$/
				var regJane = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]+$/
				var item = item.trim()
				item = item.toUpperCase()
				var regCar = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{1})$/
				var numarr = item.split('')
				var j, str, isnum
				for (var i = 0; i < numarr.length; i++) {
					if (i == 0) {
						if (!regJane.test(numarr[i])) return item = item.slice(0, 0)
					} else if (i >= 1) {
						if (i == 1) {
							if (!regALP.test(numarr[i])) return item = item.slice(0, item.length - 1)
							str = item.slice(0, 2)
							if (regCar.test(str)) {
								this.maxl = 8
								isnum = true
							} else {
								this.maxl = 7
								isnum = false
								item = item.slice(0, 7)
							}
						} else {
							if (isnum == true) {
								if (i == 2) {
									if (!regNum.test(numarr[i])) return item = item.replace((numarr[i]), "")
								}
							}
							if (!regALP.test(numarr[i])) return item = item.slice(0, item.length - 1)
						}
					}
				}
				return item
			},
			// 新增保存
			preservationAdd(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.postAdd()
						this.$refs[formName].resetFields();
					} else {

						if (this.checkedCitiesGrade.length == 0) {
							this.$message({
								message: '请选择客户等级',
								type: 'error'
							});

						} else if (this.checkedCitiesHdcj.length == 0) {
							this.$message({
								message: '请选择可获得优惠券厂家',
								type: 'error'
							});
						} else if (this.checkedCitiesSycj.length == 0) {
							this.$message({
								message: '请选择可使用优惠券厂家',
								type: 'error'
							});
						}
						return false;
					}
				});
			},
			// 新增调用接口
			postAdd(formName) {
				let newArrKhdj = []
				let newArrHdcjId = []
				let newArrSycjId = []
				let newArrHdcjName = []
				let newArrSycjName = []
				this.checkedCitiesGrade.forEach(function(value, index, array) {
					newArrKhdj.push(value.SETTB206CA00)
				})
				this.checkedCitiesHdcj.forEach(function(value, index, array) {
					// console.log(value);
					newArrHdcjId.push(value.SETTB99ID)
					newArrHdcjName.push(value.SETTB99CA00)

				})
				this.checkedCitiesSycj.forEach(function(value, index, array) {
					// console.log(value);
					newArrSycjId.push(value.SETTB99ID)
					newArrSycjName.push(value.SETTB99CA00)

				})
				// console.log(newArrKhdj)
				// console.log(newArrHdcjId)
				// console.log(newArrHdcjName)
				// return
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB408CA00: this.ruleForm.name, //优惠券名称
					// SETTB408CA02: this.ruleForm.ms, //优惠券描述
					SETTB408CA01: this.ruleForm.yhje, //优惠券金额
					SETTB408CA03: this.ruleForm.hdmkje, //获得门槛金额
					SETTB408CA04: this.ruleForm.symkje, //使用门槛金额
					SETTB408CA05: this.ruleForm.sylx, //使用类型
					SETTB408CA06: newArrKhdj.toString(), //客户等级
					SETTB408CA07: newArrHdcjId.toString(), //可获得厂家ID
					SETTB408CA08: newArrSycjId.toString(), //可使用厂家ID
					SETTB408CB00: newArrHdcjName.toString(), //可获得厂家name
					SETTB408CB01: newArrSycjName.toString(), //可使用厂家name
					SETTB408CA09: this.ruleForm.jzsj, //截至时间
				}
				var url = "/set/settb408/insert";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.billOperationAdd = false;
						this.checkedCitiesGrade = []
						this.checkedCitiesHdcj = []
						this.checkedCitiesSycj = []
						this.isIndeterminate = false
						this.isIndeterminateHdcj = false
						this.isIndeterminateSycj = false
						this.checkAllGrade = false
						this.checkAllHdcj = false
						this.checkAllSycj = false
						this.$message({
							message: '新增成功',
							type: 'success'
						});
						this.pageList();

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			tareIptAddUP() { //限制验证码长度
				var value = this.tareIptAdd;
				this.tareIptAdd = this.clearNoNum(value);
			},
			tareIptModifyUP() {
				var value = this.tareIptModify;
				this.tareIptModify = this.clearNoNum(value);
			},
			// 校验车牌号重复
			checkCarNumber(val, index) {
				if (index == 0) {
					var postData = {
						SALTB416CA00: val, //车牌号
					}
				} else if (index == 1) {
					var postData = {
						SALTB416CA00: val, //车牌号
					}
				}
				var url = "/sal/saltb416/checkSaltb416ca00";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.result == 2) {
						if (index == 0) {
							this.postAdd();
						} else if (index == 1) {
							this.modifyPost()
						}
					} else {
						if (val == this.judgeCarNumMo) {
							if (index == 0) {
								this.postAdd();
							} else if (index == 1) {
								this.modifyPost()
							}
						} else {
							this.$message({
								message: res.data.message,
								type: 'error'
							});
						}
					}
				})
			},
			// 新增取消--X
			XAdd() {
				this.materielIndex = 0;
			},
			// 新增取消
			cancelAdd() {
				this.billOperationAdd = false;
				// this.materielIndex = 0;
			},
			// 新增
			newlyAdd() {
				this.billOperationAdd = true;
				this.addEdit = 0;
				// this.judgeAdd = 0;
				// this.carNumberAdd = ''; //车牌号
				// this.carNameAdd = ''; //姓名
				// this.carPhoneAdd = ''; //电话
				// this.tareIptAdd = ''
				this.customerManagementQuery()
				this.loadEnterpriseOptions()

				this.checkedCitiesGrade = []
				this.checkedCitiesHdcj = []
				this.checkedCitiesSycj = []
				this.isIndeterminate = false
				this.isIndeterminateHdcj = false
				this.isIndeterminateSycj = false
				this.checkAllGrade = false
				this.checkAllHdcj = false
				this.checkAllSycj = false

			},
			numinputModify() {
				this.carNumberModify = this.checkNum(this.carNumberModify)
			},
			// 修改保存
			preservationModify(formName) {

				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.modifyPost()
						// this.$refs[formName].resetFields();
					} else {

						if (this.checkedCitiesGrade.length == 0) {
							this.$message({
								message: '请选择客户等级',
								type: 'error'
							});

						} else if (this.checkedCitiesHdcj.length == 0) {
							this.$message({
								message: '请选择可获得优惠券厂家',
								type: 'error'
							});
						} else if (this.checkedCitiesSycj.length == 0) {
							this.$message({
								message: '请选择可使用优惠券厂家',
								type: 'error'
							});
						}
						return false;
					}
				});




			},
			modifyPost() {
				// console.log(this.checkedCitiesGrade)
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					SETTB408ID: this.rowId,
					SETTB408CA00: this.editRuleForm.name, //优惠券名称
					SETTB408CA01: this.editRuleForm.yhje, //优惠券金额
					SETTB408CA03: this.editRuleForm.hdmkje, //获得门槛金额
					SETTB408CA04: this.editRuleForm.symkje, //使用门槛金额
					SETTB408CA05: this.editRuleForm.sylx, //使用类型
					SETTB408CA06: this.checkedCitiesGrade.toString(), //客户等级
					SETTB408CA07: this.checkedCitiesHdcj.toString(), //可获得厂家ID
					SETTB408CA08: this.checkedCitiesSycj.toString(), //可使用厂家ID
					SETTB408CA09: this.editRuleForm.jzsj //截至时间
				}
				var url = "/set/settb408/update";
				this.axios.post(url, postData).then(res => {
					// console.log(res)

					if (res.data.code == 200) {
						this.billOperationDetails = false;
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.pageList();

					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close();
				})
			},
			// 修改取消
			cancelModify() {
				this.billOperationDetails = false;
			},
			// 修改
			modify(row) {
				// console.log(row)
				this.customerManagementQuery()
				this.loadEnterpriseOptions()
				// console.log(this.editRuleForm)

				this.addEdit = 1
				this.rowId = row.SETTB408ID
				this.editRuleForm.name = row.SETTB408CA00
				this.editRuleForm.yhje = row.SETTB408CA01
				this.editRuleForm.hdmkje = row.SETTB408CA03
				this.editRuleForm.symkje = row.SETTB408CA04
				this.editRuleForm.sylx = row.SETTB408CA05
				this.editRuleForm.jzsj = row.SETTB408CA09
				let _this = this

				var khmr = row.SETTB408CA06.split(',') //客户等级
				var khdcj = row.SETTB408CA07.split(',') //可获得券厂家
				var ksycj = row.SETTB408CA08.split(',') //可使用券厂家
				this.checkedCitiesGrade = khmr;
				this.checkedCitiesHdcj = khdcj;
				this.checkedCitiesSycj = ksycj;
				setTimeout(function() {
					// console.log(_this.editRuleForm.sycj)
					_this.checkAllGrade = khmr.length === _this.editRuleForm.grade.length;
					_this.checkAllHdcj = khdcj.length === _this.editRuleForm.hdcj.length;
					_this.checkAllSycj = ksycj.length === _this.editRuleForm.sycj.length;

					_this.isIndeterminate = khmr.length > 0 && khmr.length < _this.editRuleForm.grade.length;
					_this.isIndeterminateHdcj = khdcj.length > 0 && khdcj.length < _this.editRuleForm.hdcj.length;
					_this.isIndeterminateSycj = ksycj.length > 0 && ksycj.length < _this.editRuleForm.sycj.length;


				}, 500);
				this.billOperationDetails = true;
			},
			// 查询
			queryClick() {
				this.pageMo = 1
				this.pageList()
			},
			// 列表
			pageList() {
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					// SETTB402CA00: this.carNum, //车牌号
					// sign: this.userobj.pertb005.pertb005cb00,
					// personID: ORMTB400ID,
					page: this.pageMo,
					limit: this.limitMo
				}

				this.tableData = [];
				var moList;
				var url = "/set/settb408/selectPageList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					setTimeout(() => {
						loading.close()
					}, 300)
					if (res.data.code == 200) {
						moList = res.data.data;
						for (var i = 0; i < moList.length; i++) {
							this.tableData.push({
								SETTB408ID: moList[i]['SETTB408ID'], //每条数据ID
								SETTB408CA06: moList[i]['SETTB408CA06'], //客户ID
								SETTB408CA07: moList[i]['SETTB408CA07'], //获得券厂家ID
								SETTB408CA08: moList[i]['SETTB408CA08'], //使用券厂家ID
								SETTB408CA00: moList[i]['SETTB408CA00'], //优惠券名称
								SETTB408CA05: moList[i]['SETTB408CA05'], //优惠券类型
								SETTB408CA01: moList[i]['SETTB408CA01'], //优惠券金额
								SETTB408CA02: moList[i]['SETTB408CA02'], //优惠券描述
								SETTB408CA03: moList[i]['SETTB408CA03'], //获得优惠券门槛金额
								SETTB408CA04: moList[i]['SETTB408CA04'], //使用优惠券门槛金额
								SETTB408CA09: moList[i]['SETTB408CA09'], //到期时间ID
								SETTB408CB00: moList[i]['SETTB408CB00'], //获得优惠券厂家
								SETTB408CB01: moList[i]['SETTB408CB01'], //使用优惠券厂家
							})
						}
						this.pagingPageMo = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(() => {
					loading.close();
				})
			},
			handleSizeChange(val) {
				this.pageMo = 1
				this.limitMo = val;
				this.pageList();
			},
			// 点击页码
			handleCurrentChange(val) {
				this.pageMo = val;
				this.pageList();
			},
			clearNoNum(value) {
				value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
				if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
					value = parseFloat(value);
				}
				return value;
			},

		}
	}
</script>

<style scoped>
	.carManagement {
		background: #f3f3f3;
	}

	.bcarManagement-table {
		padding: 30px 20px 0;
	}

	.test111:active {
		background-color: red !important;
	}

	/* 新增--列表宽度 */
	.billOperationRecord .systemCodePC-add-code-table-li-ipt {
		flex: 1.5;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_oparetionBlock_Menu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	.billOperationRecord .public_oparetionBlock_Menu {
		height: 45px;
		align-items: center;
	}

	.billOperationRecord {
		background-color: #f3f3f3;
	}

	.billOperationRecord th,
	.billOperationRecord td {
		text-align: center !important;
	}

	/* 弹框 */
	.systemCodePC-add-code {
		padding: 0 20px;
	}
	.systemCodePC-pagesize {
		text-align: right;
		margin-top: 20px;
	}

	.el-form-item__label {
		width: 200px !important;
	}
	
	::v-deep input::-webkit-outer-spin-button,
	::v-deep input::-webkit-inner-spin-button {
	  -webkit-appearance: none !important;
	}
	::v-deep input[type='number'] {
	  -moz-appearance: textfield !important;
	  }
	  .el-input-group{
		  width: 20%;
	  }
	
</style>
<style scoped>
	.el-tooltip__popper {
		width: 400px;
		line-height: 20px !important;
		background: #595959 !important;
	}

	.el-tooltip__popper[x-placement^=top] .popper__arrow:after {
		border-top-color: #595959 !important;
	}
</style>
<style>
.sales-coupon-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-coupon-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-coupon-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-coupon-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-coupon-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
